import React from 'react'
import About from '../../components/about/About'
import Footer from '../../components/footer/Footer'
import Hero from '../../components/hero/Hero'
import Navbar from '../../components/navbar/Navbar'
import Services from '../../components/services/Services'
import Work from '../../components/work/Work'
import './home.css'

import { useInView } from 'react-intersection-observer'
import { useEffect } from 'react'

const Home = () => {

  const { ref, inView } = useInView({threshold: 0});

  useEffect(() =>{
    console.log(inView);
  }, [inView])

  return (
    <div className = "soft-bg" style={{position: 'relative'}}>
      <div ref={ref}>
      <Navbar/>
      </div>
      <Hero/>
      <About/>
      <Services/>
      <Work/>
      <Footer/>

    <a href='#navbar'>
      <div className={`${'go-top'} ${inView ? 'go-top-hidden' : ''}`}>
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 arrow-top" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L6.707 7.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
        </svg>
      </div>
    </a>
      <div id="contact"></div>
    </div>
  )
}

export default Home
